// extracted by mini-css-extract-plugin
export default {"container":"UserMenu_container__KolyR","email":"UserMenu_email__xoBAv","btn":"UserMenu_btn__cDmR5","img":"UserMenu_img__ZTFrC","link":"UserMenu_link__d6eY9"};